import { SIZE } from '../../../../constants/size'

export const REQUEST_EDIT_USER_COMMENT_MODAL_BOX_SIZE = SIZE.LARGE

export const REQUEST_EDIT_USER_COMMENT_MODAL_QA_NAME = 'editInvitation'

export const REQUEST_EDIT_USER_FIELDS_FIELD_NAME_IS_COMMENT = 'isComment'
